/*
 * Entro UI helpers (Oct 2026)
 * 1. Phones: cart drawer Promo + Notes move into the scrolling list (footer = subtotal + Checkout only).
 * 2. PO number field in the cart drawer, saved as cart attribute "PO Number" (prints on Order Printer).
 * 3. "In cart" badges on product cards and variant rows, kept in sync with the live cart.
 * 4. "Notify me" on out-of-stock variants (Omnisend back in stock; off until EntroUIConfig.bisFormId is set).
 *    The variant table's qty input must stay in every row (entro-bulk.js reads it).
 * 5. Account pricing: applies the customer's group discount codes (window.EntroGroup.codes) to the cart
 *    automatically, removes ones that don't apply, and shows group prices on product cards / product page.
 */
(function () {
  if (window.EntroUI) return;
  window.EntroUI = true;
  var CFG = window.EntroUIConfig || {};
  var G = window.EntroGroup || null;
  var GROUP_CODES = window.EntroGroupCodes || [];
  var mq = window.matchMedia('(max-width: 699px)');
  var nf = (window.EntroBulk && window.EntroBulk.nativeFetch) || window.fetch.bind(window);
  function jpost(url, body) {
    return nf(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Entro-Bulk': '1' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }

  /* ---------- 1. cart drawer extras placement ---------- */
  function place() {
    var d = document.querySelector('.ec');
    if (!d) return;
    var body = d.querySelector('.ec__body'), foot = d.querySelector('.ec__foot');
    if (!body || !foot) return;
    var wrap = d.querySelector('.ec__extras');
    if (!wrap) {
      var boxes = d.querySelectorAll('.ec__box');
      if (!boxes.length) return;
      wrap = document.createElement('div');
      wrap.className = 'ec__extras';
      foot.insertBefore(wrap, foot.firstChild);
      Array.prototype.forEach.call(boxes, function (b) { wrap.appendChild(b); });
    }
    if (mq.matches) { if (wrap.parentNode !== body) body.appendChild(wrap); }
    else if (wrap.parentNode !== foot) foot.insertBefore(wrap, foot.firstChild);
  }

  /* ---------- 2. PO number ---------- */
  var poTimer = null;
  function addPo() {
    var d = document.querySelector('.ec');
    if (!d || d.querySelector('.ec__po')) return;
    var box = d.querySelector('.ec__box--note');
    if (!box) return;
    var note = box.querySelector('.ec__note');
    var wrap = document.createElement('div');
    wrap.className = 'ec__po-wrap';
    wrap.innerHTML = '<label class="ec__po-label" for="ec-po">PO number <span>(optional)</span></label>' +
      '<input id="ec-po" class="ec__po" type="text" maxlength="60" autocomplete="off" placeholder="e.g. PO-10452"><span class="ec__po-status" aria-live="polite"></span>';
    box.insertBefore(wrap, note);
    var input = wrap.querySelector('.ec__po'), status = wrap.querySelector('.ec__po-status');
    function save() {
      jpost('/cart/update.js', { attributes: { 'PO Number': input.value.trim() } })
        .then(function () { status.textContent = input.value.trim() ? 'Saved \u2713' : ''; })
        .catch(function () { status.textContent = 'Not saved'; });
    }
    input.addEventListener('input', function () { status.textContent = 'Saving...'; clearTimeout(poTimer); poTimer = setTimeout(save, 700); });
    input.addEventListener('blur', function () { clearTimeout(poTimer); save(); });
    if (CART) fillPo(CART);
  }
  function fillPo(c) {
    var input = document.querySelector('.ec__po');
    if (!input || document.activeElement === input) return;
    var po = (c.attributes && c.attributes['PO Number']) || '';
    input.value = po;
    if (po) { var box = input.closest('.ec__box'); if (box && !box.hasAttribute('data-touched')) box.open = true; }
  }

  /* ---------- 3. In cart badges (live) + 5. account pricing codes ---------- */
  var CART = null, byProduct = {}, byVariant = {}, loading = false, again = false;
  function loadCart() {
    if (loading) { again = true; return; }
    loading = true;
    nf('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return syncGroup(c); })
      .then(function (c) {
        CART = c; byProduct = {}; byVariant = {};
        (c.items || []).forEach(function (it) {
          byProduct[it.product_id] = (byProduct[it.product_id] || 0) + it.quantity;
          byVariant[it.variant_id] = (byVariant[it.variant_id] || 0) + it.quantity;
        });
        paint(); fillPo(c);
      })
      .catch(function () {})
      .then(function () { loading = false; if (again) { again = false; loadCart(); } });
  }
  var reloadTimer = null;
  function queueReload() { clearTimeout(reloadTimer); reloadTimer = setTimeout(loadCart, 250); }

  /* Account pricing: keep exactly the customer's eligible group codes on the cart (promo codes are left alone) */
  var rejected = {};
  function isGroup(code) { return /^ENTRO-ACCT-/i.test(code) || GROUP_CODES.indexOf(code) !== -1; }
  function syncGroup(c) {
    var items = (c.items || []).length;
    var present = (c.discount_codes || []);
    var names = present.map(function (d) { return d.code; });
    var want = (G && G.codes) || [];
    var sig = c.total_price + ':' + c.item_count;
    /* group codes that came back "not applicable" for this cart (e.g. under the $100 / $250 minimum) are taken off and retried when the cart changes */
    present.forEach(function (d) { if (isGroup(d.code) && d.applicable === false) rejected[d.code.toUpperCase()] = sig; });
    var desired = items ? want.filter(function (code) { return rejected[code.toUpperCase()] !== sig; }) : [];
    var promos = names.filter(function (n) { return !isGroup(n); });
    var target = promos.concat(desired);
    var same = target.length === names.length && target.every(function (t) { return names.some(function (n) { return n.toUpperCase() === t.toUpperCase(); }); });
    if (same || (!items && !names.some(isGroup))) return Promise.resolve(c);
    return jpost('/cart/update.js', { discount: target.join(',') }).then(function (c2) {
      var bad = (c2.discount_codes || []).filter(function (d) { return isGroup(d.code) && d.applicable === false; });
      if (!bad.length) return c2;
      var sig2 = c2.total_price + ':' + c2.item_count;
      bad.forEach(function (d) { rejected[d.code.toUpperCase()] = sig2; });
      var keep = (c2.discount_codes || []).filter(function (d) { return !(isGroup(d.code) && d.applicable === false); }).map(function (d) { return d.code; });
      return jpost('/cart/update.js', { discount: keep.join(',') });
    }).then(function (c3) {
      if (window.EntroCart && document.querySelector('.ec[aria-hidden="false"]')) window.EntroCart.refresh();
      return c3;
    }).catch(function () { return c; });
  }

  function productIdOf(card) {
    /* NB: form.id is shadowed by the form's hidden input named "id", so read the attribute */
    var form = card.querySelector('form[id^="product_form_id_"]');
    var fid = form && form.getAttribute('id');
    var m = fid && fid.match(/^product_form_id_(\d+)_/);
    return m ? m[1] : null;
  }
  function paint() {
    if (!CART) return;
    document.querySelectorAll('.product-item').forEach(function (card) {
      var pid = productIdOf(card);
      var qty = pid ? byProduct[pid] || 0 : 0;
      var tag = card.querySelector('.ei-incart');
      if (!qty) { if (tag) tag.remove(); return; }
      if (!tag) {
        var list = card.querySelector('.product-item__label-list');
        if (!list) { list = document.createElement('div'); list.className = 'product-item__label-list'; card.insertBefore(list, card.firstChild); }
        tag = document.createElement('span');
        tag.className = 'product-label ei-incart';
        list.insertBefore(tag, list.firstChild);
      }
      var t = 'In cart \u00b7 ' + qty;
      if (tag.textContent !== t) tag.textContent = t;
      tag.title = qty + ' unit' + (qty === 1 ? '' : 's') + ' of this product in your cart';
    });
    document.querySelectorAll('.eb-row[data-id]').forEach(function (tr) {
      if (tr.closest('.eb-qo__table')) return;
      var qty = byVariant[tr.getAttribute('data-id')] || 0;
      var b = tr.querySelector('.ei-incart-v');
      tr.classList.toggle('eb-row--incart', qty > 0);
      if (!qty) { if (b) b.remove(); return; }
      if (!b) {
        var name = tr.querySelector('.eb-name');
        if (!name) return;
        b = document.createElement('span');
        b.className = 'ei-incart-v';
        name.parentNode.appendChild(b);
      }
      var t = 'In cart: ' + qty;
      if (b.textContent !== t) b.textContent = t;
    });
  }

  /* 5b. Show group prices on theme price tags (cards, product page header). Tables get them from the server. */
  function groupPrices() {
    if (!G || !G.pct) return;
    document.querySelectorAll('.product-item .price:not(.price--compare):not([data-eg]), .product-meta .price:not(.price--compare):not([data-eg])').forEach(function (el) {
      if (el.closest('.eb, .ec, .eb-modal')) return;
      el.setAttribute('data-eg', '1');
      var orig = null;
      el.innerHTML = el.innerHTML.replace(/\$\s?([\d,]+(?:\.\d{1,2})?)/g, function (m, n) {
        var cents = Math.round(parseFloat(n.replace(/,/g, '')) * 100);
        if (isNaN(cents)) return m;
        if (orig === null) orig = m;
        var now = cents - Math.round(cents * G.pct / 100);
        return '$' + (now / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      });
      el.classList.add('price--highlight');
      el.title = 'Your account price (' + G.pct + '% off)';
      var list = el.parentNode;
      if (orig && list && !list.querySelector('.price--compare')) {
        var s = document.createElement('span');
        s.className = 'price price--compare eg-was';
        s.textContent = orig;
        el.insertAdjacentElement('afterend', s);
      }
    });
  }

  ['cart:refresh', 'product:added', 'cart:updated', 'cart:change'].forEach(function (ev) {
    document.documentElement.addEventListener(ev, queueReload);
    document.addEventListener(ev, queueReload);
  });
  var rawFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(queueReload, queueReload);
    return p;
  };
  window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') queueReload(); });

  /* ---------- 4. Notify me (Omnisend back in stock) ---------- */
  function isProductPage() { return /\/products\//.test(location.pathname); }
  function openBis(variantId, productUrl) {
    if (CFG.bisFormId && isProductPage() && window.omnisend) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', variantId);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
      window.omnisend.push(['openForm', CFG.bisFormId]);
      return;
    }
    var base = (productUrl || location.pathname).split('?')[0].split('#')[0];
    location.href = base + '?variant=' + variantId + '&notify=1';
  }
  function addNotify() {
    if (!CFG.bisFormId) return;
    document.querySelectorAll('.eb-row--out[data-id]:not([data-bis])').forEach(function (tr) {
      if (tr.closest('.eb-qo__table')) return;
      tr.setAttribute('data-bis', '1');
      var cell = tr.querySelector('.eb-c-qty');
      if (!cell || cell.querySelector('.eb-notify')) return;
      var modal = tr.closest('.eb-modal');
      var pdp = modal && modal.querySelector('.eb-modal__pdp');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'eb-notify';
      btn.setAttribute('data-variant', tr.getAttribute('data-id'));
      if (pdp) btn.setAttribute('data-url', pdp.getAttribute('href'));
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 16V11a6 6 0 1 1 12 0v5l2 2H4l2-2zM10 20a2 2 0 0 0 4 0" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>Notify me';
      btn.setAttribute('aria-label', 'Email me when ' + ((tr.querySelector('.eb-name') || {}).textContent || 'this item') + ' is back in stock');
      cell.appendChild(btn);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.eb-notify');
    if (!b) return;
    e.preventDefault();
    openBis(b.getAttribute('data-variant'), b.getAttribute('data-url'));
  });
  function autoOpenFromLink() {
    try {
      var u = new URL(location.href);
      if (u.searchParams.get('notify') !== '1' || !CFG.bisFormId) return;
      var tries = 0;
      (function wait() {
        if (window.omnisend && window.omnisend.push) { window.omnisend.push(['openForm', CFG.bisFormId]); u.searchParams.delete('notify'); history.replaceState(history.state, '', u.toString()); return; }
        if (++tries < 40) setTimeout(wait, 250);
      })();
    } catch (e) {}
  }

  /* ---------- run (each step isolated so one failure can't block the others) ---------- */
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('EntroUI', e); } }
  function all() { safe(place); safe(addPo); safe(paint); safe(groupPrices); safe(addNotify); }
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; all(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  function start() { all(); loadCart(); autoOpenFromLink(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
